import { useEffect, useState } from 'react';
import { getCustomizeBoxSeasonData } from '../services/customize';

const DEFAULT_BOX_NAME = 'FabFitFun Seasonal Box';

const useBoxName = () => {
  const [boxName, setBoxName] = useState(DEFAULT_BOX_NAME);
  const fetchBoxData = async () => {
    try {
      const response = await getCustomizeBoxSeasonData();
      const responseBoxName = response?.box?.name;
      setBoxName(responseBoxName);
    } catch {
      setBoxName('FabFitFun Seasonal Box');
    }
  };

  useEffect(() => {
    fetchBoxData();
  }, []);

  return { boxName };
};

export default useBoxName;
